import { render, staticRenderFns } from "./SkipTradeArrivalAction.vue?vue&type=template&id=1a1196f5&scoped=true"
import script from "./SkipTradeArrivalAction.vue?vue&type=script&lang=js"
export * from "./SkipTradeArrivalAction.vue?vue&type=script&lang=js"
import "./SkipTradeArrivalAction.vue?vue&type=style&index=0&id=1a1196f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1196f5",
  null
  
)

export default component.exports